import { withCompInfo } from '@wix/editor-elements-integrations'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { SearchBoxCSSVars, SearchBoxDefinition } from './SearchBox'

export const css = withCompInfo<SearchBoxCSSVars, SearchBoxDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compLayout', 'styleProperties', 'siteFonts', 'isMobileView', 'isOneDocMigrated'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compLayout, styleProperties, siteFonts, isMobileView, isOneDocMigrated }) => {
		const compInfo = { compLayout, styleProperties, siteFonts, isMobileView }
		return {
			'--inputFont': getScaledFont(compInfo, 'inputFont', isOneDocMigrated),
		}
	}
)
